export enum EventType {
	COPILOT_SERVICE_READY_EVENT = 'CopilotServiceReadyEvent',
}
